import { render, staticRenderFns } from "./DemoOrders.vue?vue&type=template&id=535b43b4"
import script from "./DemoOrders.vue?vue&type=script&lang=js"
export * from "./DemoOrders.vue?vue&type=script&lang=js"
import style0 from "./DemoOrders.vue?vue&type=style&index=0&id=535b43b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports